<template>
    <button type="button"
            :disabled="disabled"
            v-cloak
            @click="handleClick"
            class="flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 transition duration-300"
            :class="[disabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700']">
        <slot>{{ name }}</slot>
    </button>
</template>

<script>
export default {
    name: "PrimaryButton",
    props: {
        name: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    methods: {
        handleClick (event) {
            this.$emit("click", event);
        }
    }
};
</script>
